/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/PuntosInteres.svg'
import i_beneficios2 from './../UI/icons/Sidebar/PuntosInteres2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'
import i_terreno from './../UI/icons/Sidebar/Terreno.svg'
import i_terreno2 from './../UI/icons/Sidebar/Terreno2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_garden from './../UI/icons/Amenities/Garden.svg'
import i_garden2 from './../UI/icons/Amenities/Garden_White.svg'
import i_oratorio from './../UI/icons/Amenities/Oratorio.svg'
import i_oratorio2 from './../UI/icons/Amenities/Oratorio_white.svg'
import i_club from './../UI/icons/Amenities/Club_LaRivera.svg'
import i_club2 from './../UI/icons/Amenities/Club_LaRivera_White.svg'
import i_spa from './../UI/icons/Amenities/Zonas humedas.svg'
import i_spa2 from './../UI/icons/Amenities/Zonas humedas_white.svg'
import i_piscina from './../UI/icons/Amenities/Piscina.svg'
import i_piscina2 from './../UI/icons/Amenities/Piscina_White.svg'
import i_deportivo from './../UI/icons/Amenities/ClubDeportivo.svg'
import i_deportivo2 from './../UI/icons/Amenities/ClubDeportivo_white.svg'
import i_circuito from './../UI/icons/Amenities/Circuito deportivo.svg'
import i_circuito2 from './../UI/icons/Amenities/Circuito deportivo_White.svg'
import i_parqu from './../UI/icons/Amenities/Parques.svg'
import i_parqu2 from './../UI/icons/Amenities/Parques_White.svg'


/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_proyectos from './../UI/icons/POI/ProyectosCercanos.svg'
import i_proyectos2 from './../UI/icons/POI/ProyectosCercanos_White.svg'
import i_restaurante from './../UI/icons/POI/Restaurantes.svg'
import i_restaurante2 from './../UI/icons/POI/Restaurantes_White.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_Entreteni from './../UI/icons/POI/Entretenimiento.svg'
import i_Entreteni2 from './../UI/icons/POI/Entretenimiento_WHite.svg'
import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,
    'terreno': i_terreno,
    'terreno2': i_terreno2,

    /*Amenidades*/
    'Jardín La Pradera': i_garden,
    'Jardín La Pradera2': i_garden2,
    'Oratorio': i_oratorio,
    'Oratorio2': i_oratorio2,
    'Club La Rivera': i_club,
    'Club La Rivera2': i_club2,
    'Spa': i_spa,
    'Spa2': i_spa2,
    'Área de piscina': i_piscina,
    'Área de piscina2': i_piscina2,
    'Circuito deportivo': i_circuito,
    'Circuito deportivo2': i_circuito2,
    'Área de Parques': i_parqu,
    'Área de Parques2': i_parqu2,
    'Club Deportivo Rivera': i_deportivo,
    'Club Deportivo Rivera2': i_deportivo2,
  

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Entretenimiento": i_Entreteni,
    "Entretenimiento2": i_Entreteni2,
    "Restaurantes": i_restaurante,
    "Restaurantes2": i_restaurante2,
    "Proyectos Cercanos": i_proyectos,
    "Proyectos Cercanos2": i_proyectos2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}